import { useEffect, useRef } from 'react';
import { useRefCallback } from './ref-callback';
export function useNextMicro(callback) {
  var isUnmountedRef = useRef(false);
  var wrapper = useRefCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return Promise.resolve().then(function () {
      if (!isUnmountedRef.current) {
        return callback.apply(void 0, args);
      }
    });
  });
  useEffect(function () {
    return function () {
      isUnmountedRef.current = true;
    };
  }, []);
  return wrapper;
}